<template lang="pug">
  ev-dialog(
    v-bind="$attrs"
    v-on="$listeners"
  )
    template(
      v-if="activateHeaderPortal"
      v-slot:header="props"
    )
      portal-target(
        :name="`${inputValue || id}.${DIALOG_SLOTS.header}`"
        :slot-props="props"
        slim
      )

    template(v-slot:content="{ close }")
      portal-target(
        :name="`${inputValue || id}.${DIALOG_SLOTS.content}`"
        :slot-props="{ close, attrs: $attrs }"
        slim
      )

    template(v-slot:actions="{ close }")
      portal-target(
        :name="`${inputValue || id}.${DIALOG_SLOTS.actions}`"
        :slot-props="{ close }"
        slim
      )
</template>

<script>
// ! FIX: не отображается контент кастомных компонентов при первом рендере при их динамической загрузке
// пока что импортировать компоненты явно (п. CompleteWorkDialog)
import EvDialog from '../EvDialog.vue';
import { DIALOG_SLOTS } from '../../dialogs';

export default {
  components: {
    EvDialog,
  },
  props: {
    id: { type: String, required: true },
    inputValue: { type: String, default: undefined },
    activateHeaderPortal: { type: Boolean, default: false },
  },
  data() {
    return {
      DIALOG_SLOTS,
    };
  },
};
</script>
